import React, { useState, useRef, Fragment } from 'react';
import { observer } from 'mobx-react-lite';
import { SVGPureIcon } from '@/ui';
import { runInAction } from 'mobx';
import planQuestionStore from './store';

const PPTChoice = observer(({ items, disable }) => {
  return null;
  return (
    <div className="w-full grid grid-cols-2 gap-16px">
      {(items || []).map((item, index) => {
        return (
          <div
            onClick={evt => {
              if (disable) return;
              items.map(_item => {
                runInAction(() => {
                  if (item.id == _item.id) {
                    _item.check = !_item.check;
                  } else {
                    _item.check = false;
                  }
                });
                return _item;
              });
            }}
            key={index}
            className="relative h-149px rounded-12px"
          >
            {item.check ? (
              <>
                <div className="absolute-center w-[calc(100%+6px)] h-[calc(100%+6px)] bg-black rounded-12px"></div>
                <div className="vh-center absolute z-3 size-24px -right-3px -top-3px rounded-tr-12px rounded-bl-12px bg-black">
                  <SVGPureIcon
                    name="ppt_choice"
                    className="size-16px text-white"
                  />
                </div>
              </>
            ) : null}
            <div
              style={{
                backgroundImage: `url(${item.pic_url})`,
              }}
              className="size-full absolute-center rounded-12px bg-cover"
            ></div>
          </div>
        );
      })}
    </div>
  );
});
export default PPTChoice;
